import axios from "axios";

export default function (token) {
  let url = "/geoservices/REST/sigmater/get_token_bbox/" + token;
  return axios.get(url).then(response => response.data);
}



// WEBPACK FOOTER //
// ./F:/Development/geoviewer2/src/services/getS3TokenBbox.js